import React from 'react';
import { Theme, makeStyles } from '@material-ui/core/styles';
import Tooltip, { TooltipProps } from '@material-ui/core/Tooltip';
import _ from 'lodash';


const useStylesBootstrap = makeStyles((theme: Theme) => ({
    arrow: {
        color: '#212B45',
    },
    tooltip: {
        backgroundColor: '#212B45',
        marginTop: 15,
        marginBottom: 15
    },
}));

const guideStylesBootstrap = (props: any) => {
    let poprerIndex = _.get(props, `toopTipStyle.popperIndex`) ? 1500 : -1;
    let backgroundColor = _.get(props, `toopTipStyle.backgroundColor`, '#a9fdfd');

    return makeStyles((theme: Theme) => ({
        // 气泡尾巴样式
        arrow: {
            color: backgroundColor,
            top: _.get(props, 'toopTipStyle.arrowTop', 'auto')
        },
        // 气泡框
        tooltip: {
            display: 'flex',
            alignItems: 'center',
            minHeight: _.get(props, `toopTipStyle.height`, 'auto'),
            backgroundColor: backgroundColor,
            color: '#000',
            marginTop: 15,
            marginBottom: 15,
            fontSize: 12
        },
        // 气泡最外层Box样式
        popper: {
            zIndex: poprerIndex,
            width: _.get(props, `toopTipStyle.width`, 'auto'),
            maxWidth: _.get(props, `toopTipStyle.maxWidth`, 'auto')
        }
    }))
}


export default function CustomizedTooltips(props: TooltipProps) {
    const classes = useStylesBootstrap();
    return <Tooltip classes={classes} {...props} />;
}

// 新手引导气泡
export function GuideTooltips(props: TooltipProps | ToolTipsStyle, toolTipsStyle: ToolTipsStyle) {
    const classes = guideStylesBootstrap(props)();
    let filterProps: any = _.omit(props, ['toopTipStyle']);
    return <Tooltip classes={classes} {...filterProps} />;
}

type ToolTipsStyle = {
    toopTipStyle: {}
}